<template>
  <div class="display-swipe-wrapper">
    <div v-if="!items.length" class="skeleton-wrapper">
      <van-skeleton :row="5" />
    </div>
    <div v-else>
      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="(item, index) of items" :key="index">
          <display-image :value="item" />
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>
<script>
import DisplayImage from './DisplayImage.vue';

export default {
  components: {
    DisplayImage,
  },
  props: {
    items: [Array],
  },
};
</script>
<style lang="less" scoped>
.display-swipe-wrapper {
  .skeleton-wrapper {
    padding-top: 16px;
  }
}
</style>
